import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import ViewUiPlus from 'view-ui-plus';
import 'view-ui-plus/dist/styles/viewuiplus.css';
import './styles/index.less';
import VueLazyLoad from 'vue3-lazyload';
import { piniaTabRouter } from '@/plugins/piniaTabIsolation';
// 自定义字体文件
import '@/assets/fonts/font.css';

import { VueMasonryPlugin } from 'vue-masonry';

import i18n from './language/index';

async function bootstrap() {
  const app = createApp(App);

  const pinia = createPinia();
  pinia.use(piniaTabRouter());
  pinia.use(piniaPluginPersistedstate);

  app.use(VueMasonryPlugin);
  app.use(router);
  app.use(i18n);
  app.use(pinia);
  app.use(VueLazyLoad, {});
  app.use(ViewUiPlus);
  await router.isReady();
  app.mount('#app');
}
bootstrap();
